<div class="v3-place-bet__body" [formGroup]="placeBetForm()">
	<p class="v3-place-bet__title">
		{{ titleSideLabel | translate }}:
		<strong>{{ selectedRunner().name }} - {{ selectedRunner().oddMarketName }}</strong>
	</p>

	<div class="v3-place-bet__inputs">
		<div class="v3-place-bet__control">
			<button type="button" [disabled]="isOddReadonly()" (click)="decrementOdd.emit()">
				<ion-icon name="remove"></ion-icon>
			</button>
			<input
				type="number"
				formControlName="odd"
				[placeholder]="'Odd' | translate"
				[readonly]="isOddReadonly()"
				[attr.inputmode]="isOddReadonly() ? 'none' : null"
				[style.pointer-events]="isOddReadonly() ? 'none' : null" />
			<button type="button" [disabled]="isOddReadonly()" (click)="incrementOdd.emit()">
				<ion-icon name="add"></ion-icon>
			</button>
		</div>

		<div class="v3-place-bet__control">
			<button type="button" (click)="decrementStake.emit()">
				<ion-icon name="remove"></ion-icon>
			</button>
			<input type="number" formControlName="stake" [placeholder]="'Stake' | translate" />
			<button type="button" (click)="incrementStake.emit()">
				<ion-icon name="add"></ion-icon>
			</button>
		</div>
	</div>

	@if (shouldShowErrors) {
		<div class="v3-place-bet__errors">
			<div>
				@if (placeBetForm().controls.odd.errors) {
					<app-form-error-message [control]="placeBetForm().controls.odd" />
				}
			</div>
			<div>
				@if ((placeBetForm().controls.stake.dirty || placeBetForm().controls.stake.touched) && placeBetForm().controls.stake.errors) {
					<app-form-error-message [control]="placeBetForm().controls.stake" />
				}
				@if (errorMessage()) {
					<span>{{ errorMessage()! | translate }}</span>
				}
			</div>
		</div>
	}

	<div class="v3-place-bet__actions">
		<button type="button" class="is-cancel" [disabled]="isPlacing()" (click)="dismiss.emit()">
			{{ 'Cancel' | translate }}
		</button>
		<button type="submit" class="is-place" [disabled]="isPlaceBetDisabled()">
			@if (isPlacing()) {
				<ion-spinner />
			} @else {
				{{ 'Place bet' | translate }}
			}
		</button>
	</div>

	<div class="v3-place-bet__quick-stakes">
		@for (stake of visibleQuickBetAmounts; track stake) {
			<button type="button" (click)="setStake.emit(stake)">+{{ stake }}</button>
		}
	</div>

	<div class="v3-place-bet__keypad">
		@for (key of keypadKeys(); track key) {
			<button type="button" [class.is-delete]="key === 'delete'" (click)="applyKeypadValue.emit(key)">
				@if (key === 'delete') {
					<ion-icon name="backspace-outline"></ion-icon>
				} @else {
					{{ key }}
				}
			</button>
		}
	</div>

	@if (isHandicapTypeMarket()) {
		<div class="v3-place-bet__ladder">
			<app-ah-ladder-pnl />
		</div>
	}

	<div class="v3-place-bet__debug" *appFeatureFlag="'exposureCalculation'">
		<ion-button size="small" color="medium" (click)="showDebugging.emit()">Debug</ion-button>
		<p>New Total Exposure: {{ totalExposureDebugging() | number: '1.0-2' }}</p>
	</div>
</div>
